import uuid from 'uuid';
import MessageType from '../constants/luciPanelMessageTypes';

/**
 * Message handler for luci panel messages.
 * @class LuciPanelMessageHandler
 */
export default class LuciPanelMessageHandler {
  /**
   * Create a LuciPanelMessageHandler
   * @param  {HTMLElement}   target   The target for which to listen to messages.
   * @param  {Function} callback The message handler callback.
   */
  constructor(target) {
    this.domain = window.location.origin;
    this.onDataPanelLoad = () => {};
    this.onDataPanelUpdate = () => {};
    this.onDataPanelSelectImage = () => {};
    this.target = target;
    window.addEventListener('message', this.onMessageReceived);
  }

  /**
   * Destroys all event handlers.  Very important to call this or event listners will persist.
   */
  destroy() {
    window.removeEventListener('message', this.onMessageReceived);
  }

  /**
   * Creates a valid message object.
   * @static
   * @param  {string} version Api version
   * @param  {string} type    Message type
   * @param  {Any} data    Data payload
   * @return {Object}         [description]
   */
  static createMessage(version, type, data) {
    return {
      version,
      type,
      data,
      id: uuid.v4()
    };
  }

  /**
   * Sets the callback for onDataPanelLoad
   * @param {Function} callback Callback to be executed for onDataPanelLoad
   */
  setOnDataPanelLoadCallBack(callback) {
    this.onDataPanelLoad = callback;
  }

  /**
   * Sets the callback for onDataPanelUpdate
   * @param {Function} callback Callback to be executed for onDataPanelUpdate
   */
  setOnDataPanelUpdateCallBack(callback) {
    this.onDataPanelUpdate = callback;
  }

  /**
   * Sets the callback for onDataPanelSelectImage
   * @param {Function} callback Callback to be executed for onDataPanelSelectImage
   */
  setOnDataPanelSelectImageCallBack(callback) {
    this.onDataPanelSelectImage = callback;
  }

  /**
   * Sends a message to the LUCI panel.
   * @param  {Any} message   Data payload to send
   */
  sendMessageToPanel(message) {
    if (!this.target || !message) {
      return;
    }

    this.target.postMessage(JSON.stringify(message), '*');
  }

  /**
   * Handles messages from the target luci panel and forwards the event to the appropriate callback.
   * @param  {Event} event Message event
   */
  onMessageReceived = (event) => {
    if (!event) {
      return;
    }

    let data = null;

    try {
      if (this.fromValidSender(event)) {
        if (typeof event.data === 'string' || event.data instanceof String) {
          data = JSON.parse(event.data);
        } else {
          data = event.data;
        }
      } else {
        console.log(`Received message from invalid sender.  Expected: '${this.domain}' | Actual: '${event.origin}'`);
        data = {
          error: `Received message from invalid sender.  Expected: '${this.domain}' | Actual: '${event.origin}'`
        };
      }
    } catch (error) {
      /**
       * @todo Handle and return errors to the callback.
       */
      console.log('Error parsing event data.');
      console.log(error);
      return;
    }

    if (!data.type) {
      return;
    }
    switch (data.type) {
      case MessageType.DATAPANEL.LOAD.REQUEST:
        this.onDataPanelLoad(data);
        break;
      case MessageType.DATAPANEL.UPDATE.REQUEST:
        this.onDataPanelUpdate(data);
        break;
      case MessageType.DATAPANEL.SELECTIMAGE.REQUEST:
        this.onDataPanelSelectImage(data);
        break;
      default:
        console.log(`Invalid message type received: ${data.type}`);
        break;
    }
  }

  /**
   * Checks the domain of the message to ensure it is from a valid sender
   * @func fromValidSender
   * @param  {Event} event Message event
   * @return {boolean}       True is valid, false otherwise.
   */
  //eslint-disable-next-line
  fromValidSender(event) {
    return true;
    /* Disabled since event.origin doesn't seem to work in tests
    if (event && event.origin !== this.domain) {
      return false;
    }
    return true;
    */
  }
}



// WEBPACK FOOTER //
// ./app/util/luciPanelMessageHandler.js